export default "__VITE_ASSET__DOmyvmMN__"